import { TEST_URL } from './const';


export const isWidthResize = (cb) => {
    let width = window.innerWidth;

    window.addEventListener(`resize`, () => {
        if (width !== window.innerWidth) {
            if (typeof cb === `function`) cb();
            width = window.innerWidth;
        }
    });
};

export const isDomMutation = (newBlock, cb) => {
    // При подгрузке контента аяксом
    const callback = function(mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        for (let mutation of mutationsList) {
            if (mutation.type === `childList`) {
                // console.log(`A child node has been added or removed.`);
                if (typeof cb === `function`) cb();
            } else if (mutation.type === `attributes`) {
                // console.log('The ' + mutation.attributeName + ` attribute was modified.`);
            }
        }
    };

    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(callback);

    // let newBlock = document.querySelector(`#deliveryDescription`);
    if (newBlock) observer.observe(newBlock, config);
};

// склонение чисел
export const num2str = (number, textArr) => {
    let text = textArr[0];
    number = Math.abs(number) % 100;
    let number1 = number % 10;

    if (number > 10 && number < 20) text = textArr[0];
    else if (number1 > 1 && number1 < 5) text = textArr[1];
    else if (number1 === 1) text = textArr[2];

    return text;
};

// Проверка на ввод нужных символов
export const testRegexInput = (evt, regex) => {
    const theEvent = evt || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);

    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
};

// куки
export const cookiePopup = (popup) => {
    if (!popup) return;

    if (!$.cookie(`StartModal`)) {
        popup.show();
        $.cookie(`StartModal`, true, { expires: 365, path: '/' });
    }
}

// Скролл к верху
export const scrollToTop = (top, speed) => {
    $([document.documentElement, document.body]).animate({
        scrollTop: top
    }, speed);
};

// Отсортировать по алфавиту
export const sortObjArrayByAlphabeth = (arr, field) => {
    let newArr = arr.sort((x, y) => {
        if (x[field] < y[field]) return -1;
        if (x[field] > y[field]) return 1;
        return 0;
    });
    return newArr;
}

// Удалить повторяющиеся элементы массива объектов
export const removeDuplicatesFromObjArray = (arr, field) => {
    let u = [];
    arr.reduce(function (a, b) {
        if (a[field] !== b[field]) u.push(b);
        return b;
    }, []);
    return u;
}

// поиск по объекту
export const searchObj = (obj, query) => {
    for (let key in obj) {
        let value = obj[key];

        if (typeof value === `object`) {
            return searchObj(value, query);
        }
        if (typeof value === `string` && value.toLowerCase().indexOf(query.toLowerCase()) > -1) {
            return obj;
        }
    }
}

export const isDev = () => {
    if (location.href.indexOf(`localhost`) !== -1 || location.href.indexOf(TEST_URL) !== -1) {
        return true;
    }

    return false;
}

// аналог parents() по атрибуту
export const findAncestorByAttr = (el, attr) => {
    while ((el = el.parentElement) && !el.hasAttribute(attr)) continue
    return el
}

// аналог parents() по классу
export const findAncestorByClassname = (el, classname) => {
    while ((el = el.parentElement) && !el.classList.contains(classname)) continue
    return el
}

// аналог siblings()
export const getSiblings = (el) => {
    // for collecting siblings
    let siblings = [];
    // if no parent, return no sibling
    if(!el.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling  = el.parentNode.firstChild;

    // collecting siblings
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== el) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
};

// скроллбары
export const setScrollbar = (arr) => {
    if (arr.length) {
        arr.forEach((el) => {
            new window.SimpleBar(el, {
                autoHide: false
            });
        });
    }
};

// задержка выполнения функции
export const debounce = (func, timeout) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

// открытие модалки
export const openModal = (src, { afterLoadCb, beforeClose, afterClose }) => {
    // if (!(src.indexOf(`notify-product`) !== -1 && $(`.modal--compare`).length && Resolutions.IS_TAB())) {
    //     $.fancybox.close();
    // }

    $.fancybox.open({
        src: src,
        type: `inline`,
        touch: false,
        autoFocus: false,
        btnTpl: {
            smallBtn: `<button type="button" class="modal__close-btn btn btn--square btn--tiny" data-fancybox-close title="Close">` +
                `<svg class="icon icon--close">
                    <use xlink:href="#close"></use>
                </svg>`
                +
                `</button>`
        },
        afterLoad(instance, el) {
            if (afterLoadCb && typeof afterLoadCb === `function`) afterLoadCb(instance, el);
        },
        beforeClose(instance, el) {
            if (beforeClose && typeof beforeClose === `function`) beforeClose(instance, el);
        },
        afterClose(instance, el) {
            if (afterClose && typeof afterClose === `function`) afterClose(instance, el);
        }
    });
};
